import { render } from "./LeftRightLayout.vue?vue&type=template&id=7cf9356b&scoped=true"
import script from "./LeftRightLayout.vue?vue&type=script&lang=js"
export * from "./LeftRightLayout.vue?vue&type=script&lang=js"

import "./LeftRightLayout.vue?vue&type=style&index=0&id=7cf9356b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf9356b"]])

export default __exports__